export enum AccountState {
  PendingActivation = 'pending_activation',
  Active = 'active',
  Deleted = 'deleted',
}
